// extracted by mini-css-extract-plugin
module.exports = {"pintxo-skeleton":"Skeleton_pintxo-skeleton__BHB36","pintxo-skeleton-shape":"Skeleton_pintxo-skeleton-shape__PAZXJ","fill-animation":"Skeleton_fill-animation__zu_s6"};